import React from "react"

import { CcLibrarySetImportFilters } from "client/store"
import { SearchBar } from "client/components"

interface SearchLibraryImportSet {
    id: string
    leftOffset?: boolean
    rightOffset?: boolean
    filters: CcLibrarySetImportFilters
    onFilter: (filters: CcLibrarySetImportFilters) => void
}

const CcLibrarySetImportSearch = ({
    id,
    leftOffset = false,
    rightOffset = false,
    filters,
    onFilter,
}: SearchLibraryImportSet) => (
    <SearchBar
        id={id}
        filters={filters}
        leftOffset={leftOffset}
        rightOffset={rightOffset}
        onFilter={onFilter}
    />
)
export default CcLibrarySetImportSearch
